import { useEffect, useRef } from 'react';

import { Delete02Icon } from '@hugeicons/core-free-icons';
import cn from 'classnames';
import { useApiUploadActions } from 'hooks/upload-actions';
import { Controller, useForm, useWatch } from 'react-hook-form';

import { ChecksSelector } from 'components/ChecksSelector/ChecksSelector';
import { Button, EditableTitle } from 'components/FormComponents';
import { IconButton } from 'components/IconButton/IconButton';

export const BundleEdit = ({
  bundle,
  company,
  forms,
  brands,
  companyChecks,
  onUpdate = () => {},
  onDelete = () => {},
  onClose = () => {},
}) => {
  const selectorRef = useRef(null);

  const { getUpload, signUpload, createUpload, deleteUpload } = useApiUploadActions();

  const { register, control, handleSubmit, reset } = useForm();

  const nameValue = useWatch({ control, name: 'name' });

  useEffect(() => {
    if (!bundle) return;

    reset({ name: bundle.name });
    selectorRef.current.reset({
      checks: bundle.checks_data,
      candidate: {
        brand_id: bundle.brand_id,
        volunteer: bundle.volunteer,
      },
    });
  }, [bundle]);

  const onSubmit = data => {
    const { checks, candidate } = data.checks_data;
    onUpdate({
      ...data,
      checks_data: checks,
      brand_id: candidate.brand_id,
      volunteer: candidate.volunteer,
    });
  };

  return (
    <form
      className="bg-neutral-1 rounded-3xl border border-neutral-4 shadow-sm flex flex-col gap-4"
      onSubmit={handleSubmit(onSubmit)}>
      <div>
        <div className="p-6 flex items-center justify-between border-b border-neutral-4">
          <div>
            <h3 className="text-xl font-medium text-neutral-7 uppercase tracking-wide">
              ({bundle.id})
            </h3>
            <div className="flex items-center justify-between">
              <EditableTitle register={register} name="name" value={nameValue} />
            </div>
            <p className="text-lg text-neutral-6">Configure and manage your bundle below</p>
          </div>
          <IconButton
            icon={Delete02Icon}
            onClick={onDelete}
            prefix="hugeicons"
            tip="Delete bundle"
            type="delete"
          />
        </div>
        <div className="bg-neutral-2 flex flex-col gap-4">
          <Controller
            control={control}
            name="checks_data"
            render={({ field: { onChange } }) => (
              <ChecksSelector
                ref={selectorRef}
                company={company}
                brands={brands}
                companyChecks={companyChecks}
                forms={forms}
                getUpload={getUpload}
                signUpload={signUpload}
                createUpload={createUpload}
                deleteUpload={deleteUpload}
                onChange={onChange}
                allowUploads
              />
            )}
          />
        </div>
      </div>
      <div className={cn('card_footer', 'u-flex-box', 'u-flex-justify-between')}>
        <Button onClick={onClose} type="secondary">
          Cancel
        </Button>
        <Button submit>Save</Button>
      </div>
    </form>
  );
};
